import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#sign_up
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSignUpParameters extends TrackEventBaseParameters {}

const trackSignUp = (parameters: TrackSignUpParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "sign_up", ...parameters }, options);
};

export default trackSignUp;
